import React, {useEffect, useRef, useState} from 'react';
import {Row, Col, Card, Button, Form, Modal} from 'react-bootstrap';
import Select from 'react-select'
import {addItem} from '../../../lib/api/registration';
import { toast } from 'react-toastify';
import classNames from "classnames";
import Flex from "../../common/Flex";
import {Add as AddPlayer} from '../player/Add'; // oba su u istom fajlu

export function Add({ initRegistration, initRows, onClose, onSave }) {
  //console.log('initEntities',initEntities)
  console.log('initRegistration',initRegistration)
  const [registration, setRegistration] = useState(initRegistration);
  const [addPlayer, setAddPlayer] = useState(null);
  const [rows, setRows] = useState(initRows);
  const [errors, setErrors] = useState({
    name: false,
    phone_1: false
  });
  const [value, setValue] = useState(null);

  useEffect(() => {
    (async () => {

    })();
  }, []);

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;

    if (value.club_entities_id) {
      toast.error(
        <span>
          <p>Ne možete registrovati igrača.</p>
          <p>Igrač je već registrovan u klubu {value.club_name}</p>
        </span>
      );
      return;
    }

    console.clear();
    console.log('registration', registration);
    console.log('value', value);

    const _data = {
      registration_id: registration.registration_id,
      player_id: value.player_id
    };

    await addItem(_data);
    onSave();
    onClose();
  };

  const handleAddPlayer = (newPlayer) => {
    const formatted = {
      value: newPlayer.player_id,
      label: `${newPlayer.name} ${newPlayer.last_name} (${formatDateTime(newPlayer.date_of_birth)})`,
      ...newPlayer // ako ti trebaju i ostali podaci kasnije
    };
    setRows(prev => [formatted, ...prev]);
    setValue(formatted); // automatski selektuj novog igrača
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // mjeseci idu od 0
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
  }

  return (
    <>
      <Card>
        <Card.Header>
          <Row className={classNames('g-2')}>
            <Col>
              <Flex>
                <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                  Spisak igrača
                </h5>
              </Flex>
            </Col>
            <Col xs="auto">
              <Button onClick={() => setAddPlayer(true)} variant="primary">
                +
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="bg-body-tertiary">
          <Form
            method="POST"
            encType="multipart/form-data"
            noValidate
            onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="contact_type_id">
                <Form.Label>Izaberi igrača</Form.Label>
                <Select
                  closeMenuOnSelect={true}
                  options={rows}
                  placeholder="Select..."
                  isMulti={false}
                  classNamePrefix="react-select"
                  value={value}
                  onChange={value => setValue(value)}
                />
              </Form.Group>
            </Row>
            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
      {addPlayer && (
        <Modal show onHide={() => setAddPlayer(false)} size="lg">
          <Modal.Body>
            <AddPlayer
              onClose={() => {
                setAddPlayer(null);
              }}
              onAdd={handleAddPlayer}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
